"use strict";

exports.__esModule = true;
var _DebounceValue = require("./DebounceValue");
Object.keys(_DebounceValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DebounceValue[key]) return;
  exports[key] = _DebounceValue[key];
});